"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CurrencyFormatter = _interopRequireDefault(require("../../common/Formatters/CurrencyFormatter"));
var _Link = _interopRequireDefault(require("../Link/Link"));
var _ButtonsContainer = _interopRequireDefault(require("./ButtonsContainer"));
var _Helper = require("./Helper");
var _DateFormatter = _interopRequireDefault(require("../../common/Formatters/DateFormatter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.ServiceBox {\n  padding: 0;\n  min-height: 200px;\n  display: flex;\n  flex-flow: column;\n  border: solid 1px #e8e8e8; }\n  .ServiceBox .ServiceBox-Header {\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 16px; }\n  .ServiceBox .ServiceBox-CheckBoxes {\n    margin-top: 24px; }\n  .ServiceBox .ServiceBox-Content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 16px 16px 0 16px; }\n    .ServiceBox .ServiceBox-Content .ServiceBox-Title {\n      color: #e41b13; }\n    .ServiceBox .ServiceBox-Content .ServiceBox-Body {\n      display: flex;\n      flex-flow: column;\n      margin-top: 24px;\n      gap: 24px; }\n      .ServiceBox .ServiceBox-Content .ServiceBox-Body .ServiceBox-Form {\n        display: flex;\n        gap: 30px; }\n        .ServiceBox .ServiceBox-Content .ServiceBox-Body .ServiceBox-Form .ServiceBox-CheckBoxes {\n          margin-top: 0; }\n      .ServiceBox .ServiceBox-Content .ServiceBox-Body .ServiceBox-QueryTitle {\n        font-size: 14px;\n        font-weight: bold; }\n      .ServiceBox .ServiceBox-Content .ServiceBox-Body .bx--link {\n        align-self: flex-start; }\n      .ServiceBox .ServiceBox-Content .ServiceBox-Body .bx--link:focus {\n        outline: none; }\n    .ServiceBox .ServiceBox-Content .ServiceBox-Description p {\n      font-size: 14px;\n      line-height: 1.29;\n      color: #4c4c4c;\n      padding-right: 8px; }\n  .ServiceBox .ServiceBox-BtnsContainer {\n    display: flex;\n    margin-top: auto; }\n  .ServiceBox .checkbox {\n    margin-bottom: 0; }\n  .ServiceBox .ServiceBox-extended-margin {\n    margin-left: -16px;\n    margin-right: -16px; }\n  .ServiceBox .ServiceBox-Btn {\n    background-color: #a8a8a8;\n    display: flex;\n    width: 100%; }\n    .ServiceBox .ServiceBox-Btn a,\n    .ServiceBox .ServiceBox-Btn p {\n      padding: 16px;\n      color: #fff;\n      display: block;\n      text-decoration: none;\n      font-size: 14px;\n      line-height: 1.5;\n      flex: 1;\n      cursor: pointer; }\n    .ServiceBox .ServiceBox-Btn:hover {\n      background: #4c4c4c; }\n  .ServiceBox .ServiceBox-Btn__dark {\n    background-color: #4c4c4c; }\n    .ServiceBox .ServiceBox-Btn__dark:hover {\n      background-color: #000000; }\n  .ServiceBox .ServiceBox-Btn__red:hover {\n    background-color: #e41b13; }\n  .ServiceBox .ServiceBox-Btn__disabled {\n    background: #d4d4d4;\n    border-color: #d4d4d4;\n    color: #ffffff; }\n    .ServiceBox .ServiceBox-Btn__disabled p:hover {\n      cursor: not-allowed;\n      background: #a8a8a8; }\n\n.ServiceBox-Subscribed {\n  background-color: #f4f4f4; }\n";
  const fileName = "ServiceSubscriptionBox_ServiceSubscriptionBox";
  const element = document.querySelector("style[data-sass-component='ServiceSubscriptionBox_ServiceSubscriptionBox']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const ServiceSubscriptionBox = props => {
  const serviceBoxRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    const height = serviceBoxRef.current.offsetHeight;
    const heightRemainder = height % 50;
    if (heightRemainder === 0) return;
    if (heightRemainder < 50) {
      const distanceToNextFifty = Math.abs(50 - heightRemainder);
      const nextFiftyHeight = height + distanceToNextFifty;
      serviceBoxRef.current.style.height = `${nextFiftyHeight}px`;
    } else {
      const distanceToNextHundred = Math.abs(100 - heightRemainder);
      const nextHundredHeight = height + distanceToNextHundred;
      serviceBoxRef.current.style.height = `${nextHundredHeight}px`;
    }
  }, []);
  let elementToRender = null;
  switch (props.type) {
    case 0:
    case 1:
      break;
    case 2:
    case 3:
      elementToRender = /*#__PURE__*/_react.default.createElement("div", {
        className: "ServiceBox-Body"
      }, /*#__PURE__*/_react.default.createElement(_Link.default, {
        target: props.options.url,
        type: 'internal',
        withIcon: true
      }, props.options.linkTitle), props.isCancelled ? /*#__PURE__*/_react.default.createElement("p", {
        className: "sia-text-16"
      }, props.translate('subscriptionBox.cancelDate', {
        cancelDate: _DateFormatter.default.formatForTable(props.options.cancelDate)
      })) : /*#__PURE__*/_react.default.createElement("p", null, _CurrencyFormatter.default.format(props.options.price), ' ', props.options.pricePhrase));
      break;
    case 4:
      elementToRender = /*#__PURE__*/_react.default.createElement(_Helper.TypeFourService, {
        checkBoxOptions: props.options.checkBoxes,
        onSave: props.onSave,
        translate: props.translate
      });
      break;
    case 5:
      elementToRender = /*#__PURE__*/_react.default.createElement(_Helper.TypeFiveService, {
        radioItemsOptions: props.options.radioItems,
        selectedValueOption: props.options.selectedValue,
        checkBoxOptions: props.options.formatBoxes,
        name: props.options.name,
        translate: props.translate,
        type: 5,
        isSubscribed: props.isSubscribed,
        isCancelled: props.isCancelled,
        onSave: props.onSave
      });
      break;
    case 6:
      elementToRender = /*#__PURE__*/_react.default.createElement(_Helper.TypeSixService, {
        dropdownConfigs: props.options.dropdownConfigs,
        onDropdownChange: props.options.onDropdownChange,
        translate: props.translate,
        isSubscribed: props.isSubscribed,
        isCancelled: props.isCancelled,
        onManage: props.onManage,
        onSubscribe: props.onSubscribe,
        onUnsubscribe: props.onUnsubscribe,
        onSave: props?.options?.isSaveButtonActive ? props.onSave : null,
        cancelDate: props.options?.cancelDate
      });
      break;
    case 7:
      elementToRender = /*#__PURE__*/_react.default.createElement(_Helper.TypeSevenService, {
        dropdownConfigs: props.options.dropdownConfigs,
        onDropdownChange: props.options.onDropdownChange,
        translate: props.translate,
        isSubscribed: props.isSubscribed,
        isCancelled: props.isCancelled,
        onManage: props.onManage,
        onSubscribe: props.onSubscribe,
        onUnsubscribe: props.onUnsubscribe,
        updateSubscription: props.options.isSaveButtonActive,
        onSave: props?.options?.isSaveButtonActive ? props.onSave : null,
        cancelDate: props.options?.cancelDate,
        resetDropdown: props.options.resetDropdown
      });
      break;
    default:
      elementToRender = null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ServiceBox ${props.type === 0 || props.isSubscribed ? 'ServiceBox-Subscribed' : ''}`,
    ref: serviceBoxRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ServiceBox-Content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ServiceBox-Header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ServiceBox-Title "
  }, /*#__PURE__*/_react.default.createElement("p", null, props.title)), /*#__PURE__*/_react.default.createElement("div", {
    className: "ServiceBox-Description"
  }, /*#__PURE__*/_react.default.createElement("p", null, props.description))), elementToRender), props.type !== 4 && props.type !== 5 && props.type !== 6 && props.type !== 7 && /*#__PURE__*/_react.default.createElement(_ButtonsContainer.default, {
    type: props.type,
    isSubscribed: props.isSubscribed,
    isCancelled: props.isCancelled,
    onManage: props.onManage,
    onSubscribe: props.onSubscribe,
    onUnsubscribe: props.onUnsubscribe,
    onSave: props?.options?.isSaveButtonActive ? props.onSave : null,
    translate: props.translate
  }));
};
ServiceSubscriptionBox.propTypes = {
  type: _propTypes.default.oneOf([0, 1, 2, 3, 4, 5, 6, 7]).isRequired,
  title: _propTypes.default.string.isRequired,
  description: _propTypes.default.string.isRequired,
  translate: _propTypes.default.func.isRequired,
  onManage: _propTypes.default.func,
  onSubscribe: _propTypes.default.func,
  onUnsubscribe: _propTypes.default.func,
  isSubscribed: _propTypes.default.bool,
  isCancelled: _propTypes.default.bool,
  options: _propTypes.default.shape({
    // For type 2 and type 3
    url: _propTypes.default.string,
    linkTitle: _propTypes.default.string,
    price: _propTypes.default.number,
    pricePhrase: _propTypes.default.string,
    cancelDate: _propTypes.default.object,
    // For type 4 and type 5
    name: _propTypes.default.string,
    radioItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      value: _propTypes.default.string,
      label: _propTypes.default.string
    })),
    selectedValue: _propTypes.default.string,
    formatBoxes: _propTypes.default.arrayOf(_propTypes.default.shape({
      value: _propTypes.default.bool,
      label: _propTypes.default.string,
      id: _propTypes.default.number
    })),
    checkBoxes: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string,
      name: _propTypes.default.string,
      isSubscribed: _propTypes.default.bool,
      isCancelled: _propTypes.default.bool
    })),
    dropdownConfigs: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string,
      name: _propTypes.default.string,
      items: _propTypes.default.arrayOf(_propTypes.default.shape({
        id: _propTypes.default.string,
        label: _propTypes.default.string
      })),
      selectedValue: _propTypes.default.shape({
        id: _propTypes.default.string,
        label: _propTypes.default.string
      }),
      required: _propTypes.default.bool,
      placeholder: _propTypes.default.string,
      helperText: _propTypes.default.string,
      narrow: _propTypes.default.bool,
      inline: _propTypes.default.bool
    })),
    onDropdownChange: _propTypes.default.func
  })
};
var _default = exports.default = ServiceSubscriptionBox;